import React from 'react'

export const EmailIcon = () => {
  return (
    <svg width='24' height='18' viewBox='0 0 24 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M23.9777 2.78158L11.8424 9.20285L0.00955297 2.93919C0.124187 1.29885 1.61125 0 3.42948 0H20.5705C22.3314 0 23.7835 1.2142 23.9777 2.78158ZM24 5.08156V14.8565C24 16.5932 22.4652 18 20.5705 18H3.42948C1.53483 18 0 16.5932 0 14.8565V5.24793L11.301 11.2285C11.6895 11.4328 12.1576 11.3948 12.4952 11.1672C12.5111 11.1613 12.5238 11.1526 12.5397 11.1438L24 5.08156Z'
        fill='current'
      />
    </svg>
  )
}
